import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { fetchAppointment } from '~/store/actions/timetable'
import { getAppointmentId } from '~/store/reducers/soap'

export const useFetchAppointment = () => {
  const dispatch = useDispatch()
  const appointmentId = useSelector(getAppointmentId)

  useEffect(() => {
    if (appointmentId) {
      dispatch(fetchAppointment(appointmentId))
    }
  }, [appointmentId])
}
